<script setup lang="ts">
import type { NewsThumbFragment } from '#graphql-operations'

const section = ['newsCategory']
const archiveSection = ['news']
const filtersCategory = await fetchArchiveFilters(section, archiveSection)

const {
  filters,
  count,
  entries,
  status,
  error,
  isFetchingNextPage,
  fetchNextPage,
  hasNextPage,
} = await useArchive<NewsThumbFragment>({
  section: archiveSection,
  queryKey: 'news',
  filtersCategory,
  filtersSection: section,
  filtersQueryParam: 'category',
  orderBy: 'date desc',
})

const hasSelection = computed(() => filters.value.length > 0)
</script>

<template>
  <section class="archiveNews pb-25 lg:pb-60">
    <ArchiveFilters
      v-model="filters"
      :filters-list="filtersCategory"
    />
    <div class="container">
      <template v-if="status === 'error' || error">
        {{ $t('an_error_occurred_while_retrieving_entry', { label: $t('news', 2) }) }}
      </template>
      <template v-else-if="status === 'success'">
        <ul v-if="count" class="layout-grid">
          <li
            v-for="data in entries"
            :key="data!.id"
            class="col-span-full"
            :class="{
              'lg:col-span-4': hasSelection || !data.featured,
            }"
          >
            <CardNews :data :featured="!hasSelection" />
          </li>
        </ul>
        <Text v-else as="div" class="typo-sans-1 text-center uppercase" :text="$t('there_are_no_entry_to_show', { label: $t('news', 2) })" />
      </template>
      <ul v-else-if="status === 'pending'" class="layout-grid">
        <li v-for="index in 6" :key="index" class="col-span-full lg:col-span-4">
          <Skeleton :index :aspect="0.8" />
        </li>
      </ul>
    </div>
    <ArchivePagination
      v-if="hasNextPage"
      :count
      :is-fetching-next-page
      :current-count="entries?.length"
      label="news"
      @fetch-next-page="fetchNextPage"
    />
  </section>
</template>
